import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/header";

function Dashboard() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  return (
    <div className="d-flex">
      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          {/* Page content area */}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
